import Alert from '@mui/material/Alert'

const MaxProvidersSelectedAlert = ({ maxProviders, currentCount }: { maxProviders?: number, currentCount?: number }): JSX.Element => {
  return <Alert severity="warning" sx={{ border: 1, borderColor: 'orange' }}>
    You have selected the maximum allowable number of providers ({ maxProviders })
    {currentCount != null && currentCount > 0 && (
      <> You currently have {currentCount} enrollment that have been previously created.</>
    )}
  </Alert>
}

export default MaxProvidersSelectedAlert
